<script>
    import { fly } from "svelte/transition";
    import { SafeArea } from "../index";
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <div style:color="red"><SafeArea position="top" /></div>
        <div class="content">
            <p>
                The env() CSS function can be used to insert the value of a user
                agent-defined environment variable into your CSS, in a similar
                fashion to the var() function and custom properties. The
                difference is that, as well as being user-agent defined rather
                than user-defined, environment variables are globally scoped to
                a document, whereas custom properties are scoped to the
                element(s) on which they are declared.
            </p>
            <p>
                In addition, unlike custom properties, which cannot be used
                outside of declarations, the env() function can be used in place
                of any part of a property value, or any part of a descriptor
                (e.g. in Media query rules). As the spec evolves, it may also be
                usable in other places such as selectors.
            </p>
            <p>
                Originally provided by the iOS browser to allow developers to
                place their content in a safe area of the viewport, the
                safe-area-inset-* values defined in the specification can be
                used to help ensure content is visible even to viewers using
                non‑rectangular displays.
            </p>
            <p>
                For example, a common issue solved by env() is that of device
                notifications covering up some of the app user interface. By
                positioning fixed elements using env() you can ensure that they
                display in a safe area of the viewport.
            </p>
            <p>
                Another use case for env() variables is for desktop Progressive
                web apps (PWAs) that use the Window Controls Overlay feature to
                take advantage of the full application window surface area.
                Using the titlebar-area-* values, they can position elements
                where the title bar would have been and ensure that content
                stays clear of the window control buttons.
            </p>

            <p>
                safe-area-inset-top, safe-area-inset-right,
                safe-area-inset-bottom, safe-area-inset-left
            </p>

            <p>
                The safe-area-inset-* variables are four environment variables
                that define a rectangle by its top, right, bottom, and left
                insets from the edge of the viewport, which is safe to put
                content into without risking it being cut off by the shape of a
                non‑rectangular display. For rectangular viewports, like your
                average laptop monitor, their value is equal to zero. For
                non-rectangular displays — like a round watch face — the four
                values set by the user agent form a rectangle such that all
                content inside the rectangle is visible.
            </p>
        </div>
        <div style:color="red"><SafeArea position="bottom" /></div>
    </div>
</div>

<style lang="less">
    @import "./example.less";
    .content {
        font-size: 16px;
        line-height: 1.7;
        p {
            margin-bottom: 20px;
        }
    }
</style>
